import { FeatureIconName } from '../../components/FeatureIcon';

export type AdminTab = 'dashboard' | 'waitlist' | 'users' | 'moderation' | 'events' | 'legal' | 'changelog';

export interface WaitlistEntry {
  id: string;
  name: string;
  email: string;
  city: string;
  state: string;
  motorcycle_type: string;
  source: string;
  created_at: string;
}

export interface UnsubscribeFeedback {
  id: string;
  email: string;
  feedback: string;
  reason: string;
  created_at: string;
}

export const TABS: { key: AdminTab; label: string; icon: FeatureIconName; context: string }[] = [
  { key: 'dashboard', label: 'Operations', icon: 'gauge', context: 'Service status, maintenance, publishing and system records.' },
  { key: 'waitlist', label: 'Waitlist', icon: 'layers', context: 'Review sign-ups, feedback and welcome-email actions.' },
  { key: 'users', label: 'Users', icon: 'users', context: 'Find accounts and manage access.' },
  { key: 'moderation', label: 'Moderation', icon: 'shield', context: 'Review reports and moderation outcomes.' },
  { key: 'events', label: 'Events', icon: 'calendar', context: 'Manage event records and participation.' },
  { key: 'legal', label: 'Legal', icon: 'edit', context: 'Edit documents and manage published versions.' },
  { key: 'changelog', label: 'Changelog', icon: 'clock', context: 'Manage release entries and beta guidance.' },
];
